import React, {useState} from "react";
import {Helmet} from "react-helmet";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import IconButton from '@material-ui/core/IconButton';
import CreateIcon from '@material-ui/icons/Create';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteIcon from '@material-ui/icons/Delete';

import Autocomplete from '@material-ui/lab/Autocomplete';

import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import Collapse from '@material-ui/core/Collapse';
import Typography from "@material-ui/core/Typography";
import { Checkbox, FormControlLabel } from "@material-ui/core";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';

import { authService } from "services/authService.js";
import apiService from "services/apiService.js";
import config from "constants/config.js";

import {utils} from "utils/index.js";
import LoadingSpinner from "components/Loading/Loading.js";

import styles from "assets/jss/material-dashboard-pro-react/views/viewInvestmentStyle.js";

import MUIDataTable from "mui-datatables";

import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

import ColorPicker from 'material-ui-color-picker';

const useStyles = makeStyles(styles);

export default function NewExperienceAsset(props) {
  const classes = useStyles();

  const [loading, setLoading] = useState(true);

  const [categoryList, setCategoryList] = useState({});
  const [file, setFile] = useState({});
  const [thumb, setThumb] = useState({});
  const [categoryError, setCategoryError] = useState(false);

  const [asset, setAsset] = useState({});

  const [uploading, setUploading] = useState(false);
  const [fileError, setFileError] = useState(false);
  const [fileErrorText, setFileErrorText] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [assetId, setAssetId] = useState("");


  const [loadingBackground, setLoadingBackground] = useState(true);
  const [backgroundList, setBackgroundList] = useState([]);

  const [loadingForeground, setLoadingForeground] = useState(true);
  const [foregroundList, setForegroundList] = useState([]);

  const [loadingMusic, setLoadingMusic] = useState(true);
  const [musicList, setMusicList] = useState([]);
  
  React.useEffect(() => {
    apiService(config.api_url + "?type=get_experience_category", "POST", {}, function(categoryRes) {
      setCategoryList([...categoryRes.data]);
      setLoading(false);
    }, function(categoryErr) {
      setLoading(false);
      console.log(categoryErr);
    });
  }, []);

  React.useEffect(() => {
    apiService(config.api_url + "?type=get_assets", "POST", {}, function(res) {
      setBackgroundList([...res.data]);
      setLoadingBackground(false);
    }, function(err) {
      setLoadingBackground(false);
      console.log(err);
    });
  }, []);

  React.useEffect(() => {
    apiService(config.api_url + "?type=get_foreground_assets", "POST", {}, function(res) {
      setForegroundList([...res.data]);
      setLoadingForeground(false);
    }, function(err) {
      setLoadingForeground(false);
      console.log(err);
    });
  }, []);

  React.useEffect(() => {
    apiService(config.api_url + "?type=get_music_assets", "POST", {}, function(categoryRes) {
      setMusicList([...categoryRes.data]);
      setLoadingMusic(false);
    }, function(categoryErr) {
      setLoadingMusic(false);
      console.log(categoryErr);
    });
  }, []);

  return (
    <div>
      <Helmet>
        <title>New Experience Asset | {config.appName}</title>
      </Helmet>
      <GridContainer>
        {(loading || uploading || loadingBackground || loadingForeground || loadingMusic) && <LoadingSpinner opacity={uploading ? 1 : 0.2} />}
        {(!loading && !loadingBackground && !loadingForeground && !loadingMusic) && (<GridItem xs={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={9} lg={6}>
              <Box px={2} py={1} className={classes.titleBox}>
                <h3 className={classes.title}>
                  New Experience Asset
                </h3>
              </Box>
              <Card>
                <CardBody>
                  <ValidatorForm onSubmit={e => {
                    e.preventDefault();

                    if (!asset.category_id) {
                      setCategoryError(true);
                    }

                    if (!file.name) {
                      setFileError(true);
                      setFileErrorText("You must select asset.");
                      return;
                    }

                    let formData = new FormData();
                    formData.append("type", "upload_experience_asset");
                    formData.append("category_id", asset.category_id);
                    formData.append("title", asset.title);
                    formData.append("background_id", asset.background_id);
                    formData.append("foreground_id", asset.foreground_id);
                    formData.append("music_id", asset.music_id);
                    if (file && file !== {})
                      formData.append("thumbFileToUpload", file);

                    formData.append("width", asset.width);
                    formData.append("height", asset.height);
                    formData.append("x", asset.x);
                    formData.append("y", asset.y);
                    formData.append("color", asset.color ? utils.hexToRgba(asset.color) : "rgba(0,0,0,1)");
                    formData.append("grayscale", asset.grayscale ? 1 : 0);
                    formData.append("musicloop", asset.musicloop ? 1 : 0);

                    setUploading(true);
                    apiService(config.api_url, "POST", formData, function(response) {
                      setUploading(false);
                      setOpenModal(true);
                      setAssetId(response.assetId);
                    }, function(err) {
                      setUploading(false);
                      console.log(err);
                    })
                  }}>
                    <Box py={1}>
                      <TextValidator 
                        name="title"
                        label="Title"
                        value={asset.title ? asset.title : ""}
                        variant="outlined"
                        fullWidth={true}
                        className={classes.input}
                        validators={['required']}
                        errorMessages={['This field is required.']}
                        onChange={e => {
                          asset.title = e.target.value;
                          setAsset({...asset});
                        }}
                        error={fileError}
                        helperText={fileError ? fileErrorText : ""}
                      />
                    </Box>
                    <Box py={1}>
                      <TextField
                        select
                        value={asset.category_id ? parseInt(asset.category_id) : 0}
                        className={classes.selectType}
                        label="Category"
                        variant="outlined"
                        fullWidth={true}
                        onChange={e => {
                          asset.category_id = e.target.value;
                          setAsset({...asset});
                          setCategoryError(false);
                        }}
                        error={categoryError}
                        helperText={categoryError ? "Please select category" : ""}
                      >
                        <MenuItem aria-label="None" value={0} >Select Type</MenuItem>
                        {categoryList.map((category, key) => {
                          return <MenuItem aria-label="None" value={parseInt(category.id)} key={key} >{category.category}</MenuItem>
                        })}
                      </TextField>
                    </Box>
                    <Box py={1} className={classes.flexBox}>
                      <Link
                        href="#"
                        component="label"
                      >
                        Select Thumbnail<input
                          type="file"
                          id="attachFile"
                          hidden
                          onChange={e => {
                            setFile(e.target.files[0]);
                          }}
                          name="attachments"
                        />
                      </Link>
                      {(file !== {}) && <p>
                        {file.name}
                      </p>}
                    </Box>
                    <Box py={1}>
                      <Autocomplete
                        value={asset.background_id}
                        options={backgroundList}
                        getOptionLabel={(option) => option.title}
                        renderInput={(params) => <TextField {...params} label="Background Asset" variant="outlined" />}
                        onChange={(event, newValue) => {
                          asset.background_id = newValue?.id;
                          setAsset({...asset});
                        }}
                        getOptionSelected={(option, value) => {
                          return option.id === value.background_id
                        }}
                      />
                    </Box>
                    <Box py={1}>
                      <Autocomplete
                        value={asset.foreground_id}
                        options={foregroundList}
                        getOptionLabel={(option) => option.title}
                        renderInput={(params) => <TextField {...params} label="Foreground Asset" variant="outlined" />}
                        onChange={(event, newValue) => {
                          asset.foreground_id = newValue?.id;
                          setAsset({...asset});
                        }}
                        getOptionSelected={(option, value) => {
                          return option.id === value.foreground_id
                        }}
                      />
                    </Box>
                    <Box py={1}>
                      <Autocomplete
                        value={asset.music_id}
                        options={musicList}
                        getOptionLabel={(option) => option.title}
                        renderInput={(params) => <TextField {...params} label="Music Asset" variant="outlined" />}
                        onChange={(event, newValue) => {
                          asset.music_id = newValue?.id;
                          setAsset({...asset});
                        }}
                        getOptionSelected={(option, value) => {
                          return option.id === value.music_id
                        }}
                      />
                    </Box>
                    <Box py={1}>
                      <Typography
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold"
                        }}
                      >
                        Size of Foreground
                      </Typography>
                    </Box>
                    <Box py={1}>
                      <TextValidator 
                        name="width"
                        label="Width Multiplier(0~1)"
                        value={asset.width ? asset.width : ""}
                        variant="outlined"
                        fullWidth={true}
                        className={classes.input}
                        validators={['required', 'isFloat', 'minFloat:0', 'maxFloat:1']}
                        errorMessages={['This field is required.', 'This field is number.', 'This field should be greater than 0.', 'This field should be smaller than 1']}
                        onChange={e => {
                          asset.width = e.target.value;
                          setAsset({...asset});
                        }}
                      />
                    </Box>
                    <Box py={1}>
                      <TextValidator 
                        name="height"
                        label="Height Multiplier(0~1)"
                        value={asset.height ? asset.height : ""}
                        variant="outlined"
                        fullWidth={true}
                        className={classes.input}
                        validators={['required', 'isFloat', 'minFloat:0', 'maxFloat:1']}
                        errorMessages={['This field is required.', 'This field is number.', 'This field should be greater than 0.', 'This field should be smaller than 1']}
                        onChange={e => {
                          asset.height = e.target.value;
                          setAsset({...asset});
                        }}
                      />
                    </Box>
                    <Box py={1}>
                      <Typography
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold"
                        }}
                      >
                        Location of Foreground
                      </Typography>
                    </Box>
                    <Box py={1}>
                      <TextValidator 
                        name="x"
                        label="X Multiplier(0~2)"
                        value={asset.x ? asset.x : ""}
                        variant="outlined"
                        fullWidth={true}
                        className={classes.input}
                        validators={['required', 'isFloat', 'minFloat:0', 'maxFloat:2']}
                        errorMessages={['This field is required.', 'This field is number.', 'This field should be greater than 0.', 'This field should be smaller than 2']}
                        onChange={e => {
                          asset.x = e.target.value;
                          setAsset({...asset});
                        }}
                      />
                    </Box>
                    <Box py={1}>
                      <TextValidator 
                        name="y"
                        label="Y Multiplier(0~2)"
                        value={asset.y ? asset.y : ""}
                        variant="outlined"
                        fullWidth={true}
                        className={classes.input}
                        validators={['required', 'isFloat', 'minFloat:0', 'maxFloat:2']}
                        errorMessages={['This field is required.', 'This field is number.', 'This field should be greater than 0.', 'This field should be smaller than 2']}
                        onChange={e => {
                          asset.y = e.target.value;
                          setAsset({...asset});
                        }}
                      />
                    </Box>
                    <Box py={1}>
                      <Typography
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold"
                        }}
                      >
                        Filter Color
                      </Typography>
                    </Box>
                    <Box py={1}>
                      <ColorPicker
                        name="color"
                        label="Filter Color"
                        defaultValue={asset.color ? asset.color : "Change Color"}
                        value={asset.color ? asset.color : "Change Color"}
                        onChange={color => {
                          if (!color)
                            return;
                          asset.color = color;
                          setAsset({...asset});
                        }}
                        variant="outlined"
                        fullWidth
                      />
                    </Box>
                    <Box py={1}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={(e) => {
                              // console.log(e.target.checked);
                              asset.grayscale = e.target.checked;
                              setAsset({...asset});
                            }}
                            checked={asset.grayscale ? asset.grayscale : false}
                          />
                        }
                        label={
                          <span>
                            Grayscale
                          </span>
                        }
                      />
                    </Box>
                    <Box py={1}>
                      <Typography
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold"
                        }}
                      >
                        Music Loop
                      </Typography>
                    </Box>
                    <Box py={1}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={(e) => {
                              // console.log(e.target.checked);
                              asset.musicloop = e.target.checked;
                              setAsset({...asset});
                            }}
                            checked={asset.musicloop ? asset.musicloop : false}
                          />
                        }
                        label={
                          <span>
                            Music
                          </span>
                        }
                      />
                    </Box>
                    <Box py={1} className={classes.rightButton}>
                      <Button type="submit" size="lg">
                        Add
                      </Button>
                    </Box>
                  </ValidatorForm>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
          <Modal
            className={classes.modal}
            open={openModal}
            closeAfterTransition
            disableBackdropClick={true}
            disableEscapeKeyDown={true}>
            <Fade in={openModal}>
              <div className={classes.paper}>
                <h3 id="transition-modal-title">Added New Asset</h3>
                <Box className={classes.twoButton}>
                  <Button size="lg" onClick={e => {
                    props.history.push("/dashboard/experienceasset/view/" + assetId);
                  }}>
                    Go to view
                  </Button>
                  <Button size="lg" onClick={e => {
                    setOpenModal(false);
                    setAsset({});
                    setAssetId("");
                  }}>
                    Continue to add
                  </Button>
                </Box>
              </div>
            </Fade>
          </Modal>
        </GridItem>)}
      </GridContainer>
    </div>
  )
}